/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable prefer-arrow-callback */
import React from 'react';
import {
  Box,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import {
  add, getMonth,
} from 'date-fns';
import { styled } from '@mui/system';
import CustomCalendar from '@/components/CustomCalendar';
import { pr } from '@/utils/pxToRem';
import { style } from '@/styles/globals';
import IOSSwitch from '@/components/IosSwitch';

const StyledContainer = styled('div')({
  textAlign: 'center',
  backgroundColor: 'white',
  zIndex: 1,
  width: '100%',
  marginBottom: pr`16px`,
  marginTop: pr`16px`,
});

const CalendarFareInMonth = ({
  dayPriceObj, selectedDate, month, onSearchFlight,
}: any) => {
  const diffMonthToNow = month || (getMonth(new Date()) - getMonth(new Date()));
  const dataList = Array(3).fill({});
  const [showLunar, setShowLunar] = React.useState(false);
  return (
    <Box
      sx={{
        width: 'calc(100% + 16px)',
        background: '#FFFFFF',
        /* Popup-Section Shadow */
        ml: '-8px',
        mt: pr`8px`,
        height: '511px',
        boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
        borderRadius: '12px',
        overflow: 'scroll',
      }}
    >
      {dataList.map((_, idx) => {
        const nextMonth = add(new Date(), { months: idx + diffMonthToNow });
        const monthString = nextMonth.getMonth() + 1;
        const GroupTitleBar = () => (
          <StyledContainer>
            {idx === 0 && (
            <FormGroup
              style={{
                display: 'block',
                textAlign: 'end',
                marginTop: '14px',
              }}
            >
              <FormControlLabel
                style={{
                  justifyContent: 'flex-end',
                }}
                componentsProps={{
                  typography: {
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
                control={(
                  <IOSSwitch
                    size="small"
                    color="secondary"
                    defaultChecked={showLunar}
                  />
            )}
                label={(
                  <Typography
                    sx={{ ml: pr`4px` }}
                    variant="body2"
                  >
                    Hiển thị lịch âm
                  </Typography>
)}
                defaultChecked={showLunar}
                onChange={(value: any) => setShowLunar(value?.target?.checked)}
              />
            </FormGroup>
            )}
            <Typography
              variant="body1"
              fontWeight="700"
              color={style.color.black4}
              sx={{ mt: pr`16px` }}
            >
              {`Tháng ${monthString}, ${nextMonth.getFullYear()}`}

            </Typography>
          </StyledContainer>
        );

        return (
          <div
            key={idx.toString()}
            style={{
              borderRadius: '4px',
              marginTop: 16,
            }}
          >
            <GroupTitleBar />
            <CustomCalendar
              showCalendarLunar={showLunar}
              highlightToday={idx === 0}
              monthAdded={idx + diffMonthToNow}
              dayPriceObj={dayPriceObj}
              selectedDate={selectedDate}
              setSelectedDate={onSearchFlight}
            />
          </div>
        );
      })}
    </Box>
  );
};

export default CalendarFareInMonth;
